const NUMERIC_FIELDS_TO_SUM = [
  'daily_ticket_count',
  'daily_orders',
  'daily_ticket_revenue',
  'daily_ticket_fees',
  'daily_ticket_taxes',
  'daily_discounts',
  'daily_merch_count',
  'daily_merch_revenue',
  'daily_merch_taxes',
  'cumulative_tickets',
  'cumulative_merch',
  'cumulative_merch_revenue',
  'cumulative_ticket_revenue',
  'cumulative_discounts',
  'total_orders',
  'total_ticket_fees',
  'total_ticket_taxes',
];

const numericFieldsSet = new Set(NUMERIC_FIELDS_TO_SUM);

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const hasValue = (value) => value !== null && value !== undefined && value !== '';

/**
 * Aggregates ticket sales rows that share the same event_id and sale_date
 * by summing additive metrics and preserving descriptive fields.
 */
export const aggregateDailyTicketSales = (records = []) => {
  if (!Array.isArray(records)) {
    return records;
  }

  if (records.length === 0) {
    return [];
  }

  const grouped = new Map();
  const insertionOrder = [];
  const passthrough = [];

  records.forEach((record) => {
    const eventId = record?.event_id;
    const saleDate = record?.sale_date;

    if (!eventId || !saleDate) {
      passthrough.push(record);
      return;
    }

    const key = `${eventId}-${saleDate}`;
    const existing = grouped.get(key);

    if (!existing) {
      const clone = { ...record };
      clone.id = key;
      clone.sources = record?.source ? [record.source] : [];
      NUMERIC_FIELDS_TO_SUM.forEach((field) => {
        clone[field] = toNumber(record?.[field]);
      });
      grouped.set(key, clone);
      insertionOrder.push(key);
      return;
    }

    NUMERIC_FIELDS_TO_SUM.forEach((field) => {
      const increment = toNumber(record?.[field]);
      if (increment !== 0) {
        existing[field] = (existing[field] || 0) + increment;
      }
    });

    Object.keys(record).forEach((field) => {
      if (numericFieldsSet.has(field) || field === 'id' || field === 'sources') {
        return;
      }
      if (!hasValue(existing[field]) && hasValue(record[field])) {
        existing[field] = record[field];
      }
    });

    if (record?.source) {
      const sourcesSet = new Set(existing.sources || []);
      sourcesSet.add(record.source);
      existing.sources = Array.from(sourcesSet);
      existing.source = existing.sources.length === 1 ? existing.sources[0] : 'multiple';
    }
  });

  const aggregated = insertionOrder.map((key) => grouped.get(key));
  return aggregated.concat(passthrough);
};

export default aggregateDailyTicketSales;
